export default "__VITE_ASSET__cc1672fd__"